import React from 'react';
import { useInView } from 'react-intersection-observer';
import DesktopSlider from './DesktopSlider';

import { sliderWrapper } from './DesktopLayout.module.scss';

export default function DesktopLayout({ items }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  return (
    <div className={sliderWrapper} ref={inViewRef}>
      {inView && <DesktopSlider items={items} />}
    </div>
  );
}
